// Quantity limits, shared by the form validation and the page level guards so
// the number the user sees in the message is the number that is enforced.
// Generating to a file is the only way past MAX_KEYS_QUANTITY_IN_TABLE.
export const MAX_KEYS_QUANTITY = 50000;
export const MAX_KEYS_QUANTITY_IN_TABLE = 30;

export interface GenerateKeysList {
    keysQuantity: number;
    userId: number;
    productId?: number;
    reseller: string;
    allowedActivationCount: number;
    isGenerateFile: boolean;
}

export type LicenseKey = string;
export type LicenseKeysCollection = Array<LicenseKey>;
